export default "__VITE_ASSET__BLbmljcj__"